<div class="sort-panel-wr">
  <button #sortButton class="btn outline-btn icon icon-refresh" (click)="togglePanel($event)" [attr.aria-expanded]="isOpen"
  [attr.aria-label]="'SORTS_PANEL.BTN_ICON_SORT' | translate">{{ 'SORTS_PANEL.BTN_ICON_SORT' | translate }}</button>

  @if (isOpen) {
    <div #panel class="sort-panel" (click)="onPanelContentClick($event)" role="dialog" [attr.aria-label]="'SORTS_PANEL.SORT_OPTIONS_PANEL' | translate">
      <div class="panel-header">
        <h4>{{ 'SORTS_PANEL.SORT_OPTIONS' | translate }}</h4>
        <button class="close-btn" (click)="cancel()" [attr.aria-label]="'SORTS_PANEL.CLOSE_SORT_PANEL' | translate">×</button>
      </div>
      <div class="panel-content" [formGroup]="form">
        <div class="form-group">
          <label for="sort-by">{{ 'SORTS_PANEL.SORT_BY' | translate }}</label>
          <app-custom-dropdown
            id="sort-by"
            [fieldLabel]="'Sort by'"
            formControlName="sortKey"
            [isMultiselect]="false"
            [showSelectionChips]="true"
            [options]="sortKeyOptions"
            [optionLabel]="'text'"
            [optionValue]="'id'"
            [translateOptionLabel]="false"
            [placeholder]="'SORTS_PANEL.SELECT_AN_OPTION' | translate"
            [searchMode]="'local'"
            [showSearchbox]="false"
            [showClear]="false"
            [compactUi]="true"
            [pageSize]="99">
          </app-custom-dropdown>
        </div>
        <div class="form-group">
          <label for="direction">{{ 'SORTS_PANEL.SORT_DIRECTION' | translate }}</label>
          <app-custom-dropdown
            id="direction"
            [fieldLabel]="'Direction'"
            formControlName="sortDirection"
            [isMultiselect]="false"
            [showSelectionChips]="true"
            [options]="directionOptions"
            [optionLabel]="'text'"
            [optionValue]="'id'"
            [translateOptionLabel]="true"
            [placeholder]="'SORTS_PANEL.SELECT_AN_OPTION' | translate"
            [searchMode]="'local'"
            [showSearchbox]="false"
            [showClear]="false"
            [compactUi]="true"
            [pageSize]="2">
          </app-custom-dropdown>
        </div>
      </div>
      <div class="sortpanel-actions">
        <button type="button" class="btn text-btn clear-btn" (click)="clear()" [disabled]="form.invalid">{{ 'SORTS_PANEL.BTN_CLEAR' | translate }}</button>
        <div class="flex gap-2 action-group">
          <!--
          <button type="button" class="btn btn-cancel" (click)="cancel()">{{ 'SORTS_PANEL.BTN_CANCEL' | translate }}</button>
          -->
          <button type="button" class="btn primary-btn" (click)="apply()" [disabled]="form.invalid">{{ 'SORTS_PANEL.BTN_APPLY' | translate }}</button>
        </div>
      </div>
    </div>
  }
</div>
